export default function timezoneService($http, RESOURCES) {
  var service;

  service = {
    getAllTimezones: getAllTimezones,
  };

  return service;

  function getAllTimezones() {
    return $http.get(RESOURCES.TIMEZONE);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/timezone.service.js